import React from "react";
import ChecklistItem from "./ChecklistItem";
import { ChoiceGroup } from "./ChoiceCard";

const operationalPresenceOptions = [
  "Singapore-based operations",
  "Singapore-registered company",
  "Singapore tax resident",
  "Singapore employees",
  "Singapore office/warehouse",
  "Singapore bank account",
  "Overseas operations with Singapore presence",
  "Regional headquarters in Singapore"
];

export default function LocationOpsStep({ formData, updateFormData, errors = {} }) {
  const handleOperationalPresenceChange = (presence, checked) => {
    const currentPresence = formData.operational_presence || [];
    if (checked) {
      updateFormData({ operational_presence: [...currentPresence, presence] });
    } else {
      updateFormData({ operational_presence: currentPresence.filter(p => p !== presence) });
    }
  };

  return (
    <div id="step-ops" className="space-y-10">
      {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-3" style={{ color: '#4B5563' }} tabIndex={-1} data-step-heading>Location & Operations</h2>
        <p className="text-lg max-w-2xl mx-auto" style={{ color: '#4B5563' }}>
          Tell us about your operational presence in Singapore
        </p>
      </div>

      {/* Form Fields */}
      <div className="space-y-8">
        {/* Operational Presence Section */}
        <div className="w-full rounded-3xl bg-white/5 backdrop-blur-xl shadow-2xl border border-white/10 p-6 md:p-8">
          <ChoiceGroup
            name="operational_presence"
            role="group"
            legend="Operational Presence"
            required
            hint="Select every statement that applies. Most grants require Singapore-based operations or significant local presence."
            error={errors.operational_presence}
            className="space-y-4"
            optionsClassName="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-0"
          >
            {operationalPresenceOptions.map(presence => (
              <ChecklistItem
                key={presence}
                id={`presence-${presence}`}
                label={presence}
                checked={formData.operational_presence?.includes(presence) || false}
                onCheckedChange={(checked) => handleOperationalPresenceChange(presence, checked)}
                compact={true}
              />
            ))}
          </ChoiceGroup>

          <div className="space-y-4">
            <div className="checker-info-box mt-4">
              <div className="text-sm font-semibold mb-2">
                Grant Eligibility Note:
              </div>
              <div className="text-xs">
                Most government grants require at least 3 of the above criteria to be met. Singapore-based companies with
                local operations typically have the highest eligibility rates.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
